import type { RouteRecordRaw } from 'vue-router'

import { GIFT_CARDS } from './routes.constants'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: 'gift-cards',
      name: GIFT_CARDS.INDEX,
      component: () => import('./pages/GiftCards/GiftCards.vue'),
      meta: {
        owners: ['bot-squad-b2cservices-front'],
      },
    },
  ]
}
